import {
  createSerializer,
  parseAsString,
  parseAsStringLiteral,
} from "nuqs/server";

export const AI_CHAT_ORDER_BY_FALLBACK = "UPDATED_AT_DESC";
const AI_CHAT_ORDER_BY_QUERY_VALUES = [
  "CREATED_AT_ASC",
  "CREATED_AT_DESC",
  "UPDATED_AT_ASC",
  "UPDATED_AT_DESC",
] as const;
export const AI_CHAT_VISUALIZATION_QUERY_KEY = "viz";
export const AI_CHAT_VISUALIZATION_OFF_VALUE = "off";

export const aiChatSearchParamParsers = {
  seed: parseAsString,
  model: parseAsString,
  viz: parseAsStringLiteral([AI_CHAT_VISUALIZATION_OFF_VALUE]),
  orderBy: parseAsStringLiteral(AI_CHAT_ORDER_BY_QUERY_VALUES)
    .withDefault(AI_CHAT_ORDER_BY_FALLBACK)
    .withOptions({ clearOnDefault: false }),
  includesShared: parseAsStringLiteral(["false"]),
} as const;

/**
 * AI chat が所有する query key の更新指定。
 * `undefined` は現在値を維持し、`null` は URL から対象 key を削除する。
 */
export type AiChatSearchParamPatch = {
  seed?: string | null;
  model?: string | null;
  viz?: typeof AI_CHAT_VISUALIZATION_OFF_VALUE | null;
  orderBy?: (typeof AI_CHAT_ORDER_BY_QUERY_VALUES)[number] | null;
  includesShared?: "false" | null;
};

const serializeAiChatSearchParamsWithNuqs = createSerializer(
  aiChatSearchParamParsers,
);

/**
 * AI chat の pathname 遷移時に、所有外 query と hash を保ったまま所有 key だけを更新する。
 */
export function serializeAiChatSearchParams(
  pathname: string,
  currentSearchParams: Pick<URLSearchParams, "toString">,
  currentHash: string,
  patch: AiChatSearchParamPatch,
): string {
  const query = currentSearchParams.toString();
  const hash = currentHash
    ? currentHash.startsWith("#")
      ? currentHash
      : `#${currentHash}`
    : "";
  const base = `${pathname}${query ? `?${query}` : ""}${hash}`;
  return serializeAiChatSearchParamsWithNuqs(base, patch);
}

/** locale と workspace ID を含む AI chat 一覧の pathname を返す。 */
export function aiChatRootPath(lang: string, workspaceId: string): string {
  return `/${lang}/${encodeURIComponent(workspaceId)}/ai`;
}

/** locale、workspace ID、chat ID を含む AI chat の pathname を返す。 */
export function aiChatPath(
  lang: string,
  workspaceId: string,
  chatId: string,
): string {
  return `${aiChatRootPath(lang, workspaceId)}/${encodeURIComponent(chatId)}`;
}
